import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { IdentityContext } from "@react-beets/identity";
import { ApplicationPath } from "../../../constants";

function RegisterButton() {
  const history = useHistory();
  const { identity } = useContext(IdentityContext);

  if (identity) return null;

  const onClick = () => {
    history.push(ApplicationPath.Register);
  };
  return (
    <ListItem onClick={onClick} button={true}>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Register" />
    </ListItem>
  );
}

export default RegisterButton;
